import { createLightTheme } from "../default/Light";

const VodacomTheme = createLightTheme({ colorAccent: "#e60000" });
VodacomTheme.default.logoSize = { width: 12.8, height: 2.8 };
VodacomTheme.default.textStyle = {
  ...VodacomTheme.default.textStyle,
  color: "#08081B",
};
VodacomTheme.default.backgroundColor = "#F5F6F7";
VodacomTheme.default.modalStyle = {
  ...VodacomTheme.default.modalStyle,
  backgroundColor: "#F5F6F7",
};
VodacomTheme.default.headerStyle = {
  ...VodacomTheme.default.headerStyle,
  backgroundColor: "#F5F6F7",
  borderColor: "#F5F6F7",
};
VodacomTheme.default.navigationBar = {
  ...VodacomTheme.default.navigationBar,
  backgroundColor: "#F5F6F7",
};
VodacomTheme.default.bottomBarStyle = {
  ...VodacomTheme.default.bottomBarStyle,
  backgroundColor: "#F5F6F7",
  borderColor: "#F5F6F7",
};

VodacomTheme.default.iconButton = {
  ...VodacomTheme.default.iconButton,
  inactiveBackgroundColor: "#525365",
};
export default VodacomTheme;
